var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTailwind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 150,
    viewBox: "0 0 251 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "tailwind",
    d: "M62.75 50C71.1167 16.6667 92.0333 0 125.5 0C175.7 0 181.975 37.5 207.075 43.75C223.808 47.9167 238.45 41.6667 251 25C242.633 58.3333 221.717 75 188.25 75C138.05 75 131.775 37.5 106.675 31.25C89.9417 27.0833 75.3 33.3333 62.75 50ZM0 125C8.36667 91.6667 29.2833 75 62.75 75C112.95 75 119.225 112.5 144.325 118.75C161.058 122.917 175.7 116.667 188.25 100C179.883 133.333 158.967 150 125.5 150C75.3 150 69.025 112.5 43.925 106.25C27.1917 102.083 12.55 108.333 0 125Z",
    fill: "#44A8B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.4aefa20fa6290443f446f1adc99a7117.svg";
export { ForwardRef as ReactComponent };